import DrinkImage from '../images/foodImages/drinks/Drink_img1.jpg';

const DrinkItems = [
  { id: 1, name: '紅茶', price: 120, description: '', image: DrinkImage },
  { id: 2, name: '綠茶', price: 120, description: '', image: DrinkImage },
  { id: 3, name: '鐵觀音', price: 120, description: '', image: DrinkImage },
  { id: 4, name: '玫瑰薄荷', price: 120, description: '', image: DrinkImage },
  {
    id: 5,
    name: '美式咖啡',
    price: 180,
    description: '',
    image: DrinkImage,
  },
  { id: 6, name: '拿鐵咖啡', price: 180, description: '', image: DrinkImage },
  { id: 7, name: '熱可可咖啡', price: 180, description: '', image: DrinkImage },
  { id: 8, name: '熱意式濃縮咖啡', price: 150, description: '', image: DrinkImage },
  { id: 9, name: '熱焦糖瑪奇朵', price: 200, description: '', image: DrinkImage },
  { id: 10, name: '彩蝶', price: 180, description: '', image: DrinkImage },
  { id: 11, name: '西西里咖啡', price: 160, description: '', image: DrinkImage },
];

export default DrinkItems;
